import gql from "graphql-tag";

export const MY_HR_GET_IMPORT_USERS_COUNT = gql`
  query importUsersCount($roleFilters: RoleFilterInput) {
    importUsersCount(roleFilters: $roleFilters)
  }
`;
